import ImageCompare from "image-compare-viewer"

const init = () => {
	const element = document.getElementById("image-compare")
	if (element !== null) {
		const options = {
			// UI Theme Defaults
			controlColor: "#FFFFFF",
			controlShadow: false,
			addCircle: true,
			addCircleBlur: false,

			// Smoothing
			smoothing: true,
			smoothingAmount: 100,

			// Other options
			hoverStart: false,
			verticalMode: false,
			startingPoint: 50,
			fluidMode: false
		};

		const viewer = new ImageCompare(element, options).mount();
  }
}

if (document.readyState === 'complete') {
	setTimeout(function () {
		init()
	}, 1000)
} else {
	window.addEventListener('load', function () {
		setTimeout(function () {
			init()
		}, 1000)
	})
}
